import { useWeb3Modal } from '@web3modal/ethers5/react';
import classNames from 'classnames';

import Alert from 'src/components/Alert';
import { useWeb3Context } from 'src/context/web3';
import useDeviceSize from 'src/utils/hooks/useDeviceSize';

import MainLayout from '../MainLayout';

import classes from './index.module.less';

const EarnLayout = (props: any) => {
	const { children } = props;

	const deviceSize = useDeviceSize();

	const { address } = useWeb3Context();
	const { open } = useWeb3Modal();

	return (
		<MainLayout header={{ shadow: false }}>
			<div className={classes['earn-layout']}>
				{!address && (
					<div className="container">
						<Alert
							className={classNames('fs-12 fs-md-20 mx-auto mt-1', {
								'w-90': deviceSize !== 'mobile',
								'w-100': deviceSize === 'mobile',
							})}
						>
							You are not logged in, please{' '}
							<a className="fw-700" style={{ display: 'contents' }} onClick={() => open()}>
								Login
							</a>{' '}
							first to continue.
						</Alert>
					</div>
				)}

				<div className={classNames('container', classes.container)}>
					<div className={classes.content}>{children}</div>
				</div>
			</div>
		</MainLayout>
	);
};

export default EarnLayout;
